export default __webpack_public_path__ + "static/media/897.a87e4711.png";